<template>
  <img
    v-if="userDetails.photourl"
    :src="userDetails.photourl"
    :alt="userDetails.fname"
  />

  <span class="white--text text-uppercase" v-else
    >{{ userDetails.fname[0] }}{{ userDetails.lname[0] }}</span
  >
</template>

<script>
export default {
  name: "Avatar",
  props: {
    userDetails: {
      type: Object,
    },
  },
};
</script>

<style></style>
